// extracted by mini-css-extract-plugin
export default {"partnere":"partnere_partnere__xiOgg","textSide":"partnere_textSide__Qms+2","partnerePictureGrid":"partnere_partnerePictureGrid__1ueZG","pitch":"partnere_pitch__CGrYH"};